import type { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../../Hooks/use-user.hook';

export function IsUserCreatorRouteGuard(props: PropsWithChildren) {
  const user = useUser();

  if ((user.data?.ownedChannels.length || 0) === 0) {
    return <Navigate to='/becomeCreator' replace={true} />;
  }

  return props.children;
}
